<template>
  <Accordion v-editable="blok">
    <StoryblokComponent
      v-for="childBlok in blok.blocks"
      :key="childBlok._uid"
      :blok="childBlok"
      :is-list-numbered="blok.is_numbered"
    />
  </Accordion>
</template>

<script lang="ts" setup>
import type { SbAccordionStoryblok } from '@/types'
interface Props {
  blok: SbAccordionStoryblok
}
defineProps<Props>()
</script>
